export function routeMetaValue(route, key) {
  if (!route) return undefined;
  const matched = Array.isArray(route.matched) ? route.matched : [];
  for (let index = matched.length - 1; index >= 0; index -= 1) {
    if (matched[index].meta && matched[index].meta[key] !== undefined) {
      return matched[index].meta[key];
    }
  }
  return route.meta && route.meta[key];
}

export function pageStateOwner(route) {
  if (routeMetaValue(route, 'resetPageStateOnLeave')) return route.name;
  return routeMetaValue(route, 'preservePageStateFor');
}

export function pageStateStorageKeys(route) {
  const keys = routeMetaValue(route, 'pageFilterStorageKeys');
  return Array.isArray(keys) ? keys : [];
}

export function shouldInvalidatePageState(from, to, activeOwner) {
  const owner = routeMetaValue(from, 'resetPageStateOnLeave') ? from.name : activeOwner;
  if (!owner) return null;
  return pageStateOwner(to) === owner ? null : owner;
}
